import { apiClient } from "src/careflow/ph-core/api_client/api_client";

export type GetCcmReferralsQueryFilters = {
  type: string | null;
  status: string | null;
  person: any | null;
  userEmail: string | null;
  userFhirId: string | null;
  pagination: {
    take: number;
    page: 0;
  };
  includeParentReferrals: boolean;
};

export async function getCcmReferrals(filters: any) {
  const {
    type,
    status,
    person,
    userEmail,
    userFhirId,
    pagination: { take, page },
    includeParentReferrals = false,
  }: GetCcmReferralsQueryFilters = filters;
  let url = `/ccm/referral?take=${take}&skip=${page * take}`;

  if (type) {
    url = `${url}&type=${type}`;
  }

  if (status) {
    url = `${url}&status=${status}`;
  }

  if (userEmail) {
    url = `${url}&userEmail=${userEmail}`;
  }

  if (userFhirId) {
    url = `${url}&userFhirId=${userFhirId}`;
  }

  if (person) {
    url = `${url}&person=${person}`;
  }

  if (includeParentReferrals) {
    url = `${url}&includeParentReferrals=${1}`;
  }

  const data: any = await apiClient.get(url);

  return data;
}

export async function getCcmReferralsSummary(staftId: string) {
  const data= await apiClient.get(`/ccm/referral/summary/${staftId}`);
  return data;
}

export async function saveCcmReferral(params: any) {
  const url = `/ccm/referral/save`;
  const data: any = await apiClient.post(url, params);
  return data;
}

export async function createCcmReferralNote(note: string, referralId: string, patientId: string) {
  const url = `/ccm/referral/notes`;
  const payload = {
    note,
    referralId,
    patientId
  }
  const data= await apiClient.post(url, payload);
  return data;
}

export async function updateCcmReferral(id: number, params: any) {
  const url = `/ccm/referral/update/${id}`;
  const data: any = await apiClient.put(url, params);
  return data;
}

export async function deleteCcmReferral(id: string) {
  const data= await apiClient.delete(`ccm/referral/delete/${id}`);

  return data;
}